import { render, staticRenderFns } from "./switch-company.vue?vue&type=template&id=2fdbfdaa&"
import script from "./switch-company.vue?vue&type=script&lang=js&"
export * from "./switch-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports